import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import './VolumeSlider.css';

const VolumeSlider = ({ 
  title, 
  icon, 
  alt, 
  showSlider, 
  setShowSlider, 
  setOtherSlider, 
  volume, 
  setVolume, 
  onVolumeChange,
  ariaLabel,
  disabled = false,
  iconSize = "3.2vh"
}) => {
  const handleVolumeChange = (e) => {
    const newVolume = Number.parseFloat(e.target.value);
    setVolume(newVolume);
    onVolumeChange(newVolume);
    
    // Update CSS variable for track fill
    e.target.style.setProperty('--value', `${newVolume * 100}%`);
  };

  return (
    <>
      <Tooltip title={title} placement="top">
        <button
          onClick={() => {
            if (!disabled) {
              setShowSlider(!showSlider);
              setOtherSlider(false);
            }
          }}
          disabled={disabled}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
          }}
          aria-label={ariaLabel}
        >
          <img src={icon} alt={alt} style={{ width: iconSize, height: iconSize, filter: 'brightness(0) invert(1)' }} />
        </button>
      </Tooltip>
      {showSlider && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1vh",
            background: "rgba(0, 0, 0, 0.8)",
            padding: "0.5vh 1vh",
            borderRadius: "0.4vh",
          }}
        >
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={handleVolumeChange}
            className="volume-slider"
            aria-label={ariaLabel}
            style={{ '--value': `${volume * 100}%` }}
          />
          <span style={{ color: "white", fontSize: "1.2vh" }}>
            {Math.round(volume * 100)}%
          </span>
        </div>
      )}
    </>
  );
};

export default VolumeSlider;

VolumeSlider.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  showSlider: PropTypes.bool.isRequired,
  setShowSlider: PropTypes.func.isRequired,
  setOtherSlider: PropTypes.func.isRequired,
  volume: PropTypes.number.isRequired,
  setVolume: PropTypes.func.isRequired,
  onVolumeChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  iconSize: PropTypes.string,
};
